import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Link } from '../../Link/Link.es.js';

const TabsNavItem = ({ selected = false, ...rest })=>{
    const linkProps = {
        ...rest,
        className: classNames('cb-tabs-nav-item', {
            selected
        })
    };
    return jsx(Link, {
        ...linkProps
    });
};
TabsNavItem.displayName = 'TabsNav.Item';

export { TabsNavItem, TabsNavItem as default };
//# sourceMappingURL=TabsNav.Item.es.js.map
